import pickedObjectTypes from '../../types/pickedObjectTypes';

const isDot = (currentPickedObject: any): boolean =>
  currentPickedObject !== undefined &&
  currentPickedObject !== null &&
  (currentPickedObject.name.startsWith(pickedObjectTypes.origo) ||
    currentPickedObject.name.startsWith(pickedObjectTypes.glassStart) ||
    currentPickedObject.name.startsWith(pickedObjectTypes.glassEnd) ||
    currentPickedObject.name.startsWith(pickedObjectTypes.connection) ||
    currentPickedObject.name.startsWith(pickedObjectTypes.openingConnection) ||
    currentPickedObject.name.startsWith(pickedObjectTypes.endingConnection));

export default isDot;
